module.exports = __webpack_public_path__ + "img/gallery (3).d4831bd1.png";